(function() {
	'use strict';

	angular
		.module('pwc.model')
		.factory('Transaction', Transaction);

	Transaction.$inject = ['lodash'];

	// represents any
	function Transaction(lodash) {

		return {

			updateTotal: function updateTotal() {
				if (this.hasOwnProperty('price') && this.hasOwnProperty('qty')){
					var value = parseFloat(this.price * this.qty);
					this.total = lodash.isNaN(value) ? 0.00 : value.toFixed(2);
				}
			},

			isAddition: function isAddition(){
				return (this.type === 'purchase' && ! this.isOnOrder());
			},

			isSubtraction: function isSubtraction(){
				return this.type === 'sale' || this.type === 'drink' || this.type === 'loss' ||  this.type === 'gift';
			}

		};

	}

})();